import { Injectable } from '@angular/core';
import { default as countriesData } from '../config/countries.json';
import { CountryObj } from '../store/types';
import { StringUtils } from '../shared/utils/string-utils';

@Injectable({
  providedIn: 'root',
})
export class FlagService {
  countries: CountryObj[] = countriesData?.countries;
  flagsBaseUrl: string = 'https://hatscripts.github.io/circle-flags/flags/';

  constructor() {}

  getSelectedFlag(value: string) {
    const normalizedValue =
      StringUtils.removeDiacriticsAndConvertToLowercase(value);

    const matchingCountry = this.countries.find(
      (country: CountryObj) =>
        StringUtils.removeDiacriticsAndConvertToLowercase(country.code) ===
          normalizedValue ||
        StringUtils.removeDiacriticsAndConvertToLowercase(country.name) ===
          normalizedValue
    );

    if (matchingCountry && matchingCountry.iso2Code !== 'XR') {
      return `${
        this.flagsBaseUrl
      }${matchingCountry.iso2Code.toLowerCase()}.svg`;
    } else if (matchingCountry && matchingCountry.iso2Code === 'XR') {
      return 'assets/non-supported-country-flags/xk.svg';
    } else {
      return 'assets/images/flag-placeholder.svg';
    }
  }
  getAllFlags(countries: any[]): { [key: string]: string } {
    const flagsBaseUrls: { [key: string]: string } = {};
    countries.forEach((country: any) => {
      const iso2Code = country.iso2Code || country.iso2code;
      if (country && iso2Code !== 'XR') {
        flagsBaseUrls[country.name] = `${
          this.flagsBaseUrl
        }${iso2Code.toLowerCase()}.svg`;
      } else if (country && iso2Code === 'XR') {
        flagsBaseUrls[country.name] =
          'assets/non-supported-country-flags/xk.svg';
      } else {
        flagsBaseUrls[country.name] = 'assets/images/flag-placeholder.svg';
      }
    });

    return flagsBaseUrls;
  }
}
